module.exports = __webpack_public_path__ + "static/media/crane_demo.a87210c7.png";